import React, { HTMLAttributes } from 'react';

const StatusCircleOptions: React.FC<{
  color: string;
  style?: HTMLAttributes<HTMLDivElement>;
}> = ({ color, style }) => (
  <div
    style={{
      ...style,
      borderRadius: '50%',
      background: color,
      height: 10,
      width: 10,
    }}
  />
);

export default StatusCircleOptions;
